module.exports = __webpack_public_path__ + "images/emoji/eggplant.3175a5173728fbf223b8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/eggplant.png
// module id = 4rYO
// module chunks = 2